/** Binance wBETH — `exchangeRate()` returns ETH-per-wBETH at 1e18
 *  (`_EXCHANGE_RATE_UNIT`). Oracle-pushed once a day, and the *same*
 *  value on Ethereum and BNB (one oracle writes both deployments).
 *
 *  Not monotonic by construction: `updateExchangeRate` only enforces
 *  `>= 1e18`, so the oracle can lower the rate (slashing pass-through)
 *  down to 1.0. Never build a decoder that assumes it only rises. */
export const WbethExchangeRateAbi = [
  {
    name: 'exchangeRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
